module.exports = __webpack_public_path__ + "static/media/bar-brewery-winery-5.095b0f43.jpg";